import { DatePipe } from '@angular/common';
import { SampleDetailsDTO } from './model/sample-details-dto';
import { PrintPlateLabelService } from './../print-plate-labels/print-plate-labels-service';
import { TimeoutError } from 'rxjs';
import { NGSPrintRequest } from './../carrier/ngs-print-request';
import { ProcessListSample } from './model/process-list-sample';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { CarrierState } from '../masterdata/models/carrierState';
import { SelectItem } from 'primeng/api';
import { WorkListService } from './work-list.service';
import { WorkListRequest } from './work-list-request';
import { ModifiedSample } from './model/modified-sample';
import { Printer } from './../masterdata/models/printer';
import { Message, ConfirmationService } from 'primeng/components/common/api';
import { CarrierStatusService } from '../carrier-status/carrier-status.service';
import { ProcessStep } from '../masterdata/models/processStep-enum';
import { WorkListSample } from './model/work-list-sample';
import { NextStepProcessRequest } from './model/next-step-process-request';
import { PreparePlatesRequest } from './model/prepare-plates-request';
import { saveAs as saveByFileSaver } from 'file-saver';
import { NGSWorkfileResponse } from '../ngs-volume-adjustment/ngs-workfile-response';

interface SelectionWL {
  id: string;
  color: string;
  initials: string;
}

@Component({
  selector: 'app-work-list',
  templateUrl: './work-list.component.html',
  styleUrls: ['./work-list.component.css'],
  providers: [ConfirmationService, DatePipe]
})
export class WorkListComponent implements OnInit {
  ProcessListForm: FormGroup;
  processListObjects:CarrierState[];
  selectedProcessStepObject:CarrierState;
  processList:SelectItem[];
  processListSampleList:ProcessListSample[];
  selectedStep:string;
  submitted: boolean;
  processListCols:any[];
  workListCols:any[];
  errorHandler: ErrorHandler = new ErrorHandler;
  isReadyForSubmit:boolean;
  progressData:any;
  options:any;
  processStep: string;
  color: string;
  Initials:string;
  workList:WorkListRequest;
  workListCollection: WorkListRequest[];
  workListSelectItems: SelectItem[];
  selectedwl:SelectionWL;
  workListProgress:boolean;
  modifiedSampleList: ModifiedSample[];
  selectedItem:SelectItem;
  showWorkListPopUp = false;
  currentWorklist: WorkListRequest;
  workListSampleList: WorkListSample[];
  printers: SelectItem[] = [];
  isWorkListNotEmpty:boolean;
  nextProcessStep: ProcessStep;
  selectedWorkListSamples:WorkListSample[];
  ngsPrintRequest: NGSPrintRequest;
  selectedPrinter: Printer;
  msgs: Message[] = [];
  localLab: any;
  plateLables:string[] = [];
  plateBarcodes:string[] = [];
  plate1Barcode: string;
  plate2Barcode: string;
  plate3Barcode: string;
  plate4Barcode: string;
  returnedPlates: string[] = [];
  firstEmptyCol: number;
  samplesWithPlateBarcodesAlreadyAssigned = new Map();
  arrayOfPlatePositionsAndBarcodes: string[][];
  assignedSampleCount = 0;
  tableRowSelection = 'none';
  selectedSamplesWithPreviousPlate = new Map();

  // Plate view variables
  plateViewButtonVisible = false;
  plateViewButtonLabel = 'Plate View';
  NextButtonLabel = "Move Samples to Next Step";
  viewTable = true;
  columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  plateViewFetched = false;
  plateData:SampleDetailsDTO[] = [];
  preparePlateSuccessful: boolean;
  maxCol = 0;
  blockedMap = new Map();

  // Workfile response
  ngsWorkfileRespose: NGSWorkfileResponse = new NGSWorkfileResponse();

  blocked: boolean = false;

  platePrefixes: string[] = [];
  plate1Lable:string;
  plate2Lable:string;
  plate3Lable:string;
  plate4Lable:string;


  constructor(private datePipe: DatePipe, private carrierStatusService: CarrierStatusService, private formBuilder: FormBuilder, private _messagesService: MessagesService,
    private workListService: WorkListService, private _printPlateLabelService: PrintPlateLabelService,
    private confirmationService: ConfirmationService) {
  }

  //methods to call on the page load
  ngOnInit() {
    this.arrayOfPlatePositionsAndBarcodes = [];
    this.getProcessStepList();
    this.workListSelectItems = [];
    this.modifiedSampleList = [];
    this.workListSampleList = [];
    this.Initials = '';
    this.processListCols=[
      {field: 'libId' , header: 'Lib ID' },
      {field: 'projectName' , header: 'Project' },
      {field: 'sampleName' , header: 'Sample' },
      {field: 'sampleShortCode' , header: 'Short Code' },
      {field: 'customerFirstName', header: 'Customer' },
      {field: 'libTypeName' , header: 'Lib Type' },
      {field: 'comment' , header: 'Comment' },
      {field: 'workListRequest', header: 'Worklist'}
    ];
    this.color = '#0000ff';
}

  //Get NGS Process Step Details from MDM for drop down
  getProcessStepList(){
    this.processListObjects = [];
    this.processList = [];
    // Get list of Process Steps from MDM
    this.localLab = JSON.parse(localStorage.getItem('lab'));
    this.workListService.getProcessStepsByLab(this.localLab.lab, true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log('Process Steps List -> ', results.data);
        this.processListObjects = results.data;
        // loop in process Step objects
        for ( let i = 0; i < this.processListObjects.length; i++ ) {
          //Add to the list only when process list is enabled for the step
          if(this.processListObjects[i].processList){
            this.processList.push( { label : this.processListObjects[i].name, value: this.processListObjects[i].name });
          }
        }
      },
      error => {
        const errorMessage = error.error == null ? error.message :
                                          error.error.bbApiError == null ? error.message : error.error.bbApiError.message;
        const errorTitle = error.error == null ? error.name : error.error.bbApiError == null ? error.name : error.error.bbApiError.title;
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: errorTitle, detail: errorMessage });
      });
  }

  //Show warning for process list drop down when Work list is in progress
  onDisabledProcessListClick(){
    if(this.isWorkListModified()){
      this._messagesService.addWarningMessage({ severity: 'warning', summary: "Save the Work List", detail: "Please save Work List in progess" });
    }
  }

  // Get Sample data for selected Process step
  getProcessStepData(){
    this.modifiedSampleList = []
    this.workListProgress = false;
    this.processListSampleList = null;

    //Get process step Object for selected process list
    this.fetchSelectedProcessStepObject();

    //Get Plate prefix list for selected Process step
    this.getPlatePrefixDataForSelectedProcessStep();

	  //get the work list for the selected process step
    this.getWorkListForCurrentProcessStep();

    //Get the list of samples for the selected process step
    this.workListService.getSamplesForProcessStep(this.selectedStep).subscribe(
      results => {
        if (!results) {
          return;
        }
        // console.log("CS -> "+this.selectedStep+ "-> ", results.data);
        this.processListSampleList = results.data;

        if(!this.processListSampleList){
          this._messagesService.addErrorMessage({ severity: 'error', summary: results.bbApiError.title, detail: results.bbApiError.message });
        }
    },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  //Get process step Object for selected step
  fetchSelectedProcessStepObject(){
    this.processListObjects.forEach(processStep=>{
    if(processStep.name == this.selectedStep){
      this.selectedProcessStepObject = processStep;
    }
  });
  }

  //Get Plate prefix list for selected Process step
  getPlatePrefixDataForSelectedProcessStep(){
    this.platePrefixes = [];
    this.plate1Lable = this.plate2Lable = this.plate3Lable = this.plate4Lable = null;
    //Fetch PlatePrefix string for selected Process Step
    var platePrefixString = this.selectedProcessStepObject.platePrefixes;
    //if PlatePrefix String  valid
    if(platePrefixString){
      //fetch the prefix list split by comma
      this.platePrefixes = platePrefixString.split(',');

      //set lable from each Plate prefix
      if(this.platePrefixes.length > 0){
        this.plate1Lable = this.platePrefixes[0];
      }
      if(this.platePrefixes.length > 1){
        this.plate2Lable = this.platePrefixes[1];
      }
      if(this.platePrefixes.length > 2){
        this.plate3Lable = this.platePrefixes[2];
      }
      if(this.platePrefixes.length > 3){
        this.plate4Lable = this.platePrefixes[3];
      }
    }
  }

  // Get list of workLists for selected process step
  getWorkListForCurrentProcessStep() {
    this.workListSelectItems = [];
    this.selectedwl = null;
    // console.log('before drop down ->', this.workListSelectItems);
    this.workListService.getWorkListForCurrentProcessStep(this.selectedStep).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.workListCollection = results.data;
        // console.log('WorkList for ' + this.selectedStep + ': ', this.workListCollection);
        this.workListSelectItems = this.workListCollection.map(element => ({
          label: element.initials.trim().concat(' ').concat(element.workListId),
          value: {id: element.workListId, color: element.colorCode, initials: element.initials}
        }));
        // console.log('drop down ->', this.workListSelectItems);
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  // For work list drop down change
  selectTheWorkList() {
    this.saveTheWorkListSamples();
  }

  // When the work list selected for changes
  startWorkListProgress(){
    if(!this.selectedwl){
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Select the work list', detail: 'Please select the work list' });
      return;
    }
    //if list is not modified then reset the progress to default
    if(this.workListProgress == true && this.modifiedSampleList.length == 0){
      this.workListProgress = false;
    }
    else{
      this.workListProgress = true;
    }
  }

  // remove sample from selected work list
  removeFromWorkList(barcode: string){
    // Find sample in UI table data and update work list details
    this.processListSampleList.forEach(sample => {
      if(sample.barcode == barcode){
        sample.workListRequest = {colorCode: null, initials: null, processStepName: null, workListId: null, plateBarcodes:null};
      }
    });
    // Update the modified sample list
    this.updateModifiedSampleList(barcode, false);
  }

  // Add the sample to the selected worklist
  addToWorkList(barcode: string){
    // Get the worklist object for work list Id
    let selecedWorkListObject:WorkListRequest;
    this.workListCollection.forEach(workListObject =>{
      if(workListObject.workListId == this.selectedwl.id){
          selecedWorkListObject = workListObject;
      }
    });
    // Find sample in Process List and update worklist details
    this.processListSampleList.forEach(sample=>{
      if(sample.barcode === barcode){
        sample.workListRequest = selecedWorkListObject;
      }
    });
    // Update the modified sample list
    this.updateModifiedSampleList(barcode, true);
  }

  // Update the samples with In or Out tag
  updateModifiedSampleList(barcode:string, wlStatus: boolean){
    let indexOfSample;
    let sampleFound:boolean = false;
    let mSample: ModifiedSample = {workListId: this.selectedwl.id, sampleBarcode: barcode, isIn: wlStatus};

    // If sample already eixist get the index of the sample
    this.modifiedSampleList.forEach(eachSample=>{
      if(eachSample.sampleBarcode == barcode){
        indexOfSample = this.modifiedSampleList.indexOf(eachSample);
        sampleFound = true;
      }
    });

    // Remove the existing sample
    if(sampleFound){
      this.modifiedSampleList.splice(indexOfSample, 1);
    }
    // Add the latest sample
    this.modifiedSampleList.push(mSample);
  }

  // Enable button when work list modified
  isWorkListModified():boolean {
   if(this.modifiedSampleList.length > 0){
      return true;
    }
    return false;
  }

  // When samples are updated for selected work list
  saveWorkList(){
    this.saveTheWorkListSamples();
  }

  // Save the samples to database
  saveTheWorkListSamples(){
    if(this.modifiedSampleList.length > 0){
      // Save the work list details for samples in data base
      this.workListService.insertOrRemoveSamplesInWorkList(this.modifiedSampleList).subscribe(
        results => {
          if (!results) {
            return;
          }
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Work List Updated'});
          this.workListProgress = false;
          this.modifiedSampleList = [];
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      )
    }
  }

  //Check For Create Work List submit
  isCreateWorkListEnabled(): boolean {
    if (this.selectedStep && this.Initials.trim()) {
      return true;
    }
    return false;
  }

  //create the worklist
  createWorkList(){
    this.workList = {initials:this.Initials.trim().toUpperCase(), colorCode:this.color, processStepName:this.selectedStep, workListId:null, plateBarcodes:null};
    //save the work list for selected process step
    this.workListService.saveWorkList(this.workList).subscribe(
      results => {
        if (!results) {
          return;
        }
        // console.log("CS -> "+this.selectedStep+ "-> ", results.data);
        this.Initials = '';
        let detail = 'Work List creation is successful with id: ' + results.data.workListId;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Work List Added', detail });
        this.getWorkListForCurrentProcessStep();
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  //delete the work list
  deleteWorkList(){
    var worklistSampleCount = 0;
    this.processListSampleList.forEach(sample => {
      if (sample.workListRequest.workListId === this.selectedwl.id) {
        worklistSampleCount = 1;
      }
    })
    //If work list is not empty
    if(worklistSampleCount == 1){
      //ask for confirmation to delete
      this.confirmationService.confirm({
        message: 'Do you want to delete the work list ?',
        header: 'Delete Confirmation',
        icon: 'pi pi-info-circle',
        accept: () => {
          //call backend to delete the work list
          this.serviceCalltoDeleteWorkList(worklistSampleCount);
        },
        reject: () => {
          this._messagesService.addInfoMessage({severity:'information', summary:'Delete Rejected', detail:'You have rejected delete'});
        }
      });
    }
    //if work list is empty
    else{
      //call backend to delete the work list
      this.serviceCalltoDeleteWorkList(worklistSampleCount);
    }
  }

  //Service call to delete the work list
  serviceCalltoDeleteWorkList(sampleCount:number){
    //delete the work list for selected process step
    this.workListService.deleteWorkList(this.selectedwl.id).subscribe(
      results => {
        if(sampleCount == 1){
            // refresh the work list data and sample data for the process step
            this.getProcessStepData();
        }
        else{
          // refresh the work list data for the process step
          this.getWorkListForCurrentProcessStep();
        }
        this._messagesService.addSuccessMessage({severity:'success', summary:'Deleted', detail:'Work List deleted'});
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  //Check if sample is in current work list
  isSampleInCurrentWorkList(workListId:string){
    if(this.workListProgress && (workListId == this.selectedwl.id) ){
      return true;
    }
    return false;
  }

  //Check if the sample is not assigned to any worklist
  isSampleUnAssigned(workListId:string){
    if(this.workListProgress && !workListId){
      return true;
    }
    return false;
  }

  // used to get all the sub errors in the single string
  getSubErrors(errors:any[]){
    var errorText : string =''
    for(var e = 0; e < errors.length; e++){
      errorText += errors[e].message;
      if(e != errors.length - 1){
        errorText += (',');
      }
    }
    return errorText;
  }

  /**
   * @function
   * @description: This method is to TBD
   */
  onSubmit(value: string) {
    if(this.isReadyForSubmit){
      this.submitted = true;
      this.ProcessListForm.reset();
      document.getElementById('createdby').focus();
    }
  }
  /**
   * @function
   * @description: This method is to TBD
   */
  epoch_to_hh_mm_ss(epoch: number) {
    return new Date(epoch * 1000).toISOString().substring(11, 5)
  }

  // Get contrast color for back ground color
  getContrastYIQ(hexcolor){
    if(hexcolor){
      let r = parseInt(hexcolor.substring(1, 3), 16);
      let g = parseInt(hexcolor.substring(3, 3), 16);
      let b = parseInt(hexcolor.substring(5, 3), 16);
      let yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      return (yiq >= 128) ? 'black' : 'white';
    }
  }

  //Enable view when work list isselected and saved
  isWorkListViewEnabled():boolean {
    if(this.selectedwl && !this.isWorkListModified()){
        return true;
    }
    else{
      return false;
    }
  }

  initializeAllValuesForView() {
    this.plateViewFetched = false;
    this.plateData = [];
    this.maxCol = 0;
    this.plateViewButtonLabel = 'Plate View';
    this.viewTable = true;
    this.blocked = true;
    //allow row selection when plates not available
    if(!this.plate1Lable){
      this.tableRowSelection = 'multiple'
    }
    else{
      this.tableRowSelection = 'none'
    }
    this.assignedSampleCount = 0;
    this.preparePlateSuccessful = false;
    this.blockedMap = new Map();
    this.selectedSamplesWithPreviousPlate = new Map();
    //If current step is LIB QC and next step not available
    if(this.selectedStep == ProcessStep.LIB_QC && !this.nextProcessStep){
      //change lable to generate flx work file
      this.NextButtonLabel = 'Generate FLX Work File';
    }
    else{
      this.NextButtonLabel = 'Move Samples to Next Step';
    }
  }

  //Create view for selected work list samples
  viewWorkList() {
    this.initializeAllValuesForView();
    this.createViewForSelectedWorkList();
    this.onWorkListClose();
    //if no samples available for selectes worklist
    this.plate1Barcode = this.plate2Barcode = this.plate3Barcode  = this.plate4Barcode = "";
    if(!this.workListSampleList || this.workListSampleList.length == 0){
      this.isWorkListNotEmpty = false;
      this.blocked = false;
      return;
    }
    //Enable next step button
    this.isWorkListNotEmpty = true;

    this.workListService.getPlateAndPlateFirstEmptyColumn(this.selectedwl.id).subscribe(
      results => {

        if (!results) {
          this.blocked = false;
          return;
        }
        this.returnedPlates = results.data;

        //assign to the plate fields in UI
        this.fetchPlateBarcodesFromResults();
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );

    // Get list of printers from MDM
    this.printers = [];
    this.localLab = JSON.parse(localStorage.getItem('lab'));
    this.carrierStatusService.getPrintersList(this.localLab.lab, true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log('Printers List -> ', results.data);

        // If printer list not empty
        for ( let i = 0; i < results.data.length; i++ ) {
          this.printers.push( { label : results.data[i].name, value: results.data[i] });
        }
      },
      error => {
        const errorMessage = error.error == null ? error.message :
                                          error.error.bbApiError == null ? error.message : error.error.bbApiError.message;
        const errorTitle = error.error == null ? error.name : error.error.bbApiError == null ? error.name : error.error.bbApiError.title;
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: errorTitle, detail: errorMessage });
      });
  }

  //assign to the plate fields in UI
  fetchPlateBarcodesFromResults(){
    if(this.returnedPlates.length ===  0) {
      this.blocked = false;
      return;
    }
    this.firstEmptyCol = Number(this.returnedPlates[0]);

    if (this.firstEmptyCol < 0) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Not Valid Plate', detail: 'Please select plate with valid number of positions'});
      this.blocked = false;
      return;
    }

    this.preparePlacementArray();
    this.plateBarcodes = [];

    if(this.returnedPlates.length > 1){
      this.plate1Barcode = this.returnedPlates[1];
      this.plateBarcodes.push(this.plate1Barcode);
    }
    if(this.returnedPlates.length > 2){
      this.plate2Barcode = this.returnedPlates[2];
      this.plateBarcodes.push(this.plate2Barcode);
    }
     if(this.returnedPlates.length > 3){
      this.plate3Barcode = this.returnedPlates[3];
      this.plateBarcodes.push(this.plate3Barcode);
    }
     if(this.returnedPlates.length > 4){
      this.plate4Barcode = this.returnedPlates[4];
      this.plateBarcodes.push(this.plate4Barcode);
    }
    this.blocked = false;
  }

  //Close or open the Work List view
  onWorkListClose() {
    if(this.showWorkListPopUp === true) {
      this.showWorkListPopUp = false;
    } else {
      this.showWorkListPopUp = true;
    }
  }

  //Get Work List columns
  getWorkListCols() {
    // MDM Calls to be made here to get back worklist extra columns
    this.workListCols = [
      {field: '', header: 'Sample'},
      {field: this.selectedStep, header: 'Status'},
      {field: 'libTypeName', header: 'Libtype'},
      {field: '', header: 'Position'},
      {field: '', header: 'Batch'},
      {field: 'barcode', header: 'Barcode', visible: false}
    ];

    // let extraFields = null;
    // this.workListCols.push(extraFields);
    this.workListCols.push({field: 'comment', header: 'Comment'});

    return this.workListCols;
  }

  //Add the samples to the work list view
  createViewForSelectedWorkList() {
    this.workListSampleList = [];
    this.selectedWorkListSamples = [];
    var workListSample: WorkListSample;
    if (!this.processListSampleList || this.processListSampleList.length === 0) {
      return;
    } else {
        this.samplesWithPlateBarcodesAlreadyAssigned = new Map();
        this.processListSampleList.forEach(sample => {
        if (sample.workListRequest.workListId === this.selectedwl.id) {

          workListSample = {
            'libTypeName' : sample.libTypeName,
            'projectName' : sample.projectName,
            'sampleName' :  sample.sampleName,
            'barcode' : sample.barcode,
            'comment' : sample.comment,
            'position' :  (sample.plateBarcode === undefined || sample.plateBarcode === null ? '' : sample.plateBarcode) + ' ' + (sample.wellPosition === undefined || sample.wellPosition === null ? '' : sample.wellPosition)
          }
          this.workListSampleList.push(workListSample);
          if (sample.plateBarcode !== null && sample.plateBarcode !== undefined && sample.plateBarcode.trim() !== '') {
            this.samplesWithPlateBarcodesAlreadyAssigned.set(sample.barcode, sample.wellPosition);
          }
        }
      });
    }
  }

  //GetBarcodes for given samples
  getBarcodesForSamples(selectedSamples:WorkListSample[]):string[]{
    //get the barcodes for samples which are selected
    var selectedSampleBarcodes:string[] = [];

    selectedSamples.forEach(selectedSample =>
      {
        selectedSampleBarcodes.push(selectedSample.barcode);
      });

      return selectedSampleBarcodes;
  }

  //preapre seletected work list samples and send to back-end
  moveSamplesToNextStep(){
    this.nextProcessStep = null;
    this.blocked = true;

    this.nextProcessStep = this.selectedProcessStepObject.nextStep;
    // if next step not available and current step is not LIB QC, show error 
    if(!this.nextProcessStep && this.selectedStep != ProcessStep.LIB_QC){
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Next Step undefined', detail: 'Please contact admin for next step configuration'});
      this.blocked = false;
      return;
    }

    //if no samples are selected then show error
    if(this.selectedWorkListSamples.length == 0){
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'No samples selected', detail: 'Please select atleast a sample'});
      this.blocked = false;
      return;
    }
    //Get the barcodes for selected samples
    var selectedSampleBarcodes:string[] = this.getBarcodesForSamples(this.selectedWorkListSamples);
    //Add the details to request to back end
    var nextStepProcessRequest: NextStepProcessRequest = {
      'selectedWorkListId' : this.selectedwl.id,
      'workListBarcodes': selectedSampleBarcodes,
      'nextProcessStep' : this.nextProcessStep,
      'currentProcessStep' : this.selectedStep,
      'plateBarcodes' : this.plateBarcodes,
      'listOfSampleBarcodeAndPosition' : null
    };

    if(this.plateBarcodes.length > 0){
      // Call to place the samples in the plate
      // Create a map out of the placement array
      // if the map turns out to be empty, do nothing
      // else, attach the plates and send the movement query
      let assignedCount = 0;
      nextStepProcessRequest.listOfSampleBarcodeAndPosition = [];
      for(let entry of this.arrayOfPlatePositionsAndBarcodes) {
        if (entry[1] !== null) {
          nextStepProcessRequest.listOfSampleBarcodeAndPosition.push(entry[1] + ',' + entry[0]);
          if(++assignedCount === this.assignedSampleCount) {
            break;
          }
        }
      }

      this.selectedSamplesWithPreviousPlate.forEach((v, k) => {
        nextStepProcessRequest.listOfSampleBarcodeAndPosition.push(k + ',' + v);
      });
    }

   // send the request to back end
    this.workListService.moveSamplesToNextStep(nextStepProcessRequest).subscribe(
      results => {
        if (!results) {
          this.blocked = false;
          return;
        }

        this.ngsWorkfileRespose = results.data;
        if(this.ngsWorkfileRespose !== null && this.ngsWorkfileRespose !== undefined) {
          var currentDate = new Date();
          var dateValue  = this.datePipe.transform(currentDate, 'yy-MM-dd HH:mm');
          var str1 = dateValue.toString().replace(/-/g,'');
          var str2 = str1.toString().replace(/:/g,'');
          var filePrefix = str2.toString().replace(' ','_');

          let csvData = this.ngsWorkfileRespose.csvWorkfile;
          let blobData: Blob = new Blob([csvData], { type: 'text/plain' });
          let fileName: string;
          if(this.selectedStep == ProcessStep.LIB_PREP_START){
            fileName = filePrefix + '_RNA_Transfer_Worklist.csv';
          }
          else if(this.selectedStep == ProcessStep.CDNA_SYNTHESIS){
            fileName = filePrefix + '_cDNA_Purification_Worklist.csv';
          }
          else if(this.selectedStep == ProcessStep.END_REPAIR){
            fileName = filePrefix + '_cDNA_Lib_Prep_Worklist.csv';
          }
          else if(this.selectedStep == ProcessStep.AMPLIFICATION){
            fileName = filePrefix + '_Purification_Worklist.csv';
          }
          else if(this.selectedStep == ProcessStep.LIB_QC){
            let txtData = this.ngsWorkfileRespose.txtDataFile;
            blobData = new Blob([txtData], { type: 'text/plain' });
            fileName = filePrefix + '_FLX_LibQC.txt';
          }
          saveByFileSaver(blobData, fileName);
        }

        if(this.nextProcessStep){
          let detail = 'Current work list samples are moved to '+this.nextProcessStep;
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Samples are moved', detail });
          
          // Close the workList view dialogue
          this.onWorkListClose();
          // refresh the current process List Data
          this.getProcessStepData();
        }
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
    let event = {
      'checked' : false
    }
    this.assignWellPositionToAll(event);
  }

  onPrintButtonClick() {
    this.ngsPrintRequest = new NGSPrintRequest();
    this.ngsPrintRequest.barcodeList = [];
    let processStepObject: CarrierState = this.selectedProcessStepObject;

    if (processStepObject == null || processStepObject === undefined) {
      return;
    }
    this.ngsPrintRequest.template = processStepObject.defaultTemplate;
    if (processStepObject.defaultTemplate == null || processStepObject.defaultTemplate === undefined) {
      if (this.selectedPrinter.template == null || this.selectedPrinter.template === undefined) {
        let error: TimeoutError = new TimeoutError();
        error.name = 'Print Template Not Present';
        error.message = 'Print Template not present in both ProcessStep and Printer';
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        return;
      }
      this.ngsPrintRequest.template = this.selectedPrinter.template;
    }
    this.ngsPrintRequest.printer = this.selectedPrinter;

    this.selectedWorkListSamples.forEach(workListSample => {
      this.ngsPrintRequest.barcodeList.push(workListSample.barcode);
    });
        // Service call to print-plate-labels-service
    this._printPlateLabelService.printWorkListLabels(this.ngsPrintRequest).subscribe(
      result => {
        if(result.data) {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Print Successful',
            detail: 'Required labels printed successfully'
          });
        }
      },
      error => {
        console.log(error);
        let errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
      }
    );
  }

  //Enable printer when samples available and printer selected
  isPrinterSelected() {
    if (this.selectedPrinter === null ||  this.selectedPrinter === undefined || this.selectedWorkListSamples === null || this.selectedWorkListSamples.length === 0) {
      return false;
    }
    return true;
  }

  //prepare plates for next steps
  preparePlatesForNextStep(){
    this.plateViewFetched = false;
    this.plateLables = [];
    this.plateBarcodes = [];
    //If the sample count is more than 96, then throw error
    if(this.workListSampleList.length > 96){
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Too many samples for Plate', detail: 'Number of samples for this work list are more than plate size (96 wells)'});
      return;
    }

    //Look for lable and add to plate list
    if(this.plate1Lable){
      //Set Prefix for the plates which barcodes are empty
      if(!this.plate1Barcode || this.plate1Barcode.trim() == ""){
        this.plate1Barcode = this.plate1Lable;
      }
      //if given plate barcode not contains the required prefix
      else if(this.plate1Barcode.search(this.plate1Lable.trim()) == -1){
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Plate not belongs to the step ', detail: 'Plate '+this.plate1Barcode+' has not valid prefix for this step'});
        return;
      }
      this.plateLables.push(this.plate1Lable.trim());
      this.plateBarcodes.push(this.plate1Barcode.trim());
    }
    if(this.plate2Lable){
      if((!this.plate2Barcode || this.plate2Barcode.trim() == "")){
        this.plate2Barcode = this.plate2Lable;
      }
      else if(this.plate2Barcode.search(this.plate2Lable.trim()) == -1){
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Plate not belongs to the step ', detail: 'Plate '+this.plate2Barcode+' has not valid prefix for this step'});
        return;
      }
      this.plateLables.push(this.plate2Lable.trim());
      this.plateBarcodes.push(this.plate2Barcode.trim());
    }
    if(this.plate3Lable){
      if((!this.plate3Barcode || this.plate3Barcode.trim() == "")){
        this.plate3Barcode = this.plate3Lable;
      }
      else if(this.plate3Barcode.search(this.plate3Lable.trim()) == -1){
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Plate not belongs to the step ', detail: 'Plate '+this.plate3Barcode+' has not valid prefix for this step'});
        return;
      }
      this.plateLables.push(this.plate3Lable.trim());
      this.plateBarcodes.push(this.plate3Barcode.trim());
    }
    if(this.plate4Lable){
      if((!this.plate4Barcode || this.plate4Barcode.trim() == "")){
        this.plate4Barcode = this.plate4Lable;
      }
      else if(this.plate4Barcode.search(this.plate4Lable.trim()) == -1){
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Plate not belongs to the step ', detail: 'Plate '+this.plate4Barcode+' has not valid prefix for this step'});
        return;
      }
      this.plateLables.push(this.plate4Lable.trim());
      this.plateBarcodes.push(this.plate4Barcode.trim());
    }

    //Get the barcodes for selected samples
    var workListSampleBarcodes:string[] = this.getBarcodesForSamples(this.workListSampleList);
     //Add the details to request to back end

     let processStepObject: CarrierState = this.selectedProcessStepObject;

     var preparePlatesRequest: PreparePlatesRequest = {
      'plateLabels': this.plateLables,
      'plateBarcodes' : this.plateBarcodes,
      'sampleBarcodes': workListSampleBarcodes,
      'workListId' : this.selectedwl.id,
      'printer' : processStepObject.printer
    };

    this.blocked = true;
    // send the request to back end
    this.workListService.preparePlatesForSamples(preparePlatesRequest).subscribe(
      results => {
        if (!results) {
          this.blocked = false;
          return;
        }
        //get the resonse plate barcodes
        this.returnedPlates = results.data;

        //assign to the plate fields in UI
        this.fetchPlateBarcodesFromResults();

        this._messagesService.addSuccessMessage({
          severity: 'success',
          summary: 'Plates validation Successful',
          detail: 'Plates are prepared for given WorkList samples'
        });
        this.tableRowSelection = 'multiple';
        this.plateViewButtonVisible = true;
        this.preparePlateSuccessful = true;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    )

  }

  assignWellPositionToAll(event: any) {
    // tslint:disable-next-line:max-line-length
    if(this.plate1Barcode === '' || this.plate1Barcode === null || this.plate1Barcode === undefined || this.sampleInPositionalArray.length === 0 || this.sampleInPositionalArray === null || this.sampleInPositionalArray === undefined) {
      return;
    }
    if(event.checked) {
      let nextPos;
      // for all samplelistselectedsample find which are already in the positional array and which are not to be touched
      // for the ones that can not be touched, ignore
      // for the ones that can be touched, if they already exist in the positional array, ignore.
      // For the ones not present in the positional array, add them one by one.
      for (let sample of this.selectedWorkListSamples) {
        if (!this.samplesWithPlateBarcodesAlreadyAssigned.has(sample.barcode)) {
          if (this.sampleInPositionalArray(sample.barcode) === -1) {
            nextPos = this.nextPostionOnPlate();
            if(nextPos < 0) {
              return;
            }
            let assignedPos = this.placeOnPlateArray(sample.barcode, nextPos);
            this.updateSamplePositionOnWorkList(sample.barcode, assignedPos, true);
            this.assignedSampleCount++;
          }
        } else {
          this.selectedSamplesWithPreviousPlate.set(sample.barcode, this.samplesWithPlateBarcodesAlreadyAssigned.get(sample.barcode));
          let rowCol = this.getRowColumnNumberFromPosition(sample.position.substring(sample.position.indexOf(' ') + 1));
          this.plateData.push({'barcode' : sample.barcode, 'name' : sample.sampleName, 'projectName' : sample.projectName, 'positionRow' : rowCol[0], 'positionCol' : rowCol[1], 'newlyPlaced' : true, 'concentration':0.0, 'assayType':null});
        }
      }
    } else {
      // Make all the barcodes as null in the positional array
      // Make all the worklist samples have position as empty string
      this.assignedSampleCount = 0;
      for(let entry of this.workListSampleList) {
        if (!this.samplesWithPlateBarcodesAlreadyAssigned.has(entry.barcode)) {
          let samplePos = this.sampleInPositionalArray(entry.barcode);
          if(samplePos < 0) {
            return;
          }
          this.arrayOfPlatePositionsAndBarcodes[samplePos][1] = null;
          this.updateSamplePositionOnWorkList(entry.barcode, entry.position, false);
        } else {
          this.selectedSamplesWithPreviousPlate.delete(entry.barcode);
          this.plateData = this.plateData.filter(function (obj) {
            return obj.barcode !== entry.barcode;
          });
        }
      }
    }
  }

  assignWellPosition(event: any) {
    // Find if the sample can be touched
    // If no return
    // If yes, find the first free position in the array, and assign
    // Update the worklistsamplelist
    // tslint:disable-next-line:max-line-length
    if(this.plate1Barcode === '' || this.plate1Barcode === null || this.plate1Barcode === undefined || this.sampleInPositionalArray.length === 0 || this.sampleInPositionalArray === null || this.sampleInPositionalArray === undefined || event.data.barcode === null) {
      return;
    }
    if (!this.samplesWithPlateBarcodesAlreadyAssigned.has(event.data.barcode)) {
      let nextPos = this.nextPostionOnPlate();
      if (nextPos < 0) {
        return;
      }
      let assignedPos = this.placeOnPlateArray(event.data.barcode, nextPos);
      this.updateSamplePositionOnWorkList(event.data.barcode, assignedPos, true);
      this.assignedSampleCount++;
    } else {
      this.selectedSamplesWithPreviousPlate.set(event.data.barcode, this.samplesWithPlateBarcodesAlreadyAssigned.get(event.data.barcode));
      let rowCol = this.getRowColumnNumberFromPosition(event.data.position.substring(event.data.position.indexOf(' ') + 1));
      this.plateData.push({'barcode' : event.data.barcode, 'name' : event.data.sampleName, 'projectName' : event.data.projectName, 'positionRow' : rowCol[0], 'positionCol' : rowCol[1], 'newlyPlaced' : true,  'concentration':0.0, 'assayType':null});
    }
  }

  removedAssignedPosition(event: any) {
    // tslint:disable-next-line:max-line-length
    if (this.plate1Barcode === '' || this.plate1Barcode === null || this.plate1Barcode === undefined || this.sampleInPositionalArray.length === 0 || this.sampleInPositionalArray === null || this.sampleInPositionalArray === undefined)  {
      return;
    }
    // Find if the sample can be touched
    // If no ignore
    // If yes, remove it from the array
    // update the worklistsamplelist
    if (!this.samplesWithPlateBarcodesAlreadyAssigned.has(event.data.barcode)) {
      let samplePos = this.sampleInPositionalArray(event.data.barcode);
      if(samplePos !== -1) {
        this.arrayOfPlatePositionsAndBarcodes[samplePos][1] = null;
        this.updateSamplePositionOnWorkList(event.data.barcode, event.data.position, false);
        this.assignedSampleCount--;
      }
    } else {
      this.selectedSamplesWithPreviousPlate.delete(event.data.barcode);
      this.plateData = this.plateData.filter(function (obj) {
        return obj.barcode !== event.data.barcode;
      });
    }
  }

  /*
  Prepare the placement array from the first free column, by starting at row 'A'
  and continuing till row 'H' and till the last column of the plate.
  */
  preparePlacementArray() {
    this.arrayOfPlatePositionsAndBarcodes = [];
    let rowNums = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']
    for(let i = this.firstEmptyCol; i <= 12; i++) {
      rowNums.forEach(row => {
        this.arrayOfPlatePositionsAndBarcodes.push([row + i.toString(10), null]);
      });
    }
  }

  /**
   * Determine if the sample needs to be assigned or unassigned plate position or
   * not.
   * If sample already has plate barcode assigned, then do not touch!
   * @param barcode
   */
  sampleToBeTouched(barcode: string) {
    if(this.samplesWithPlateBarcodesAlreadyAssigned.has(barcode)) {
      return false;
    }
    return true;
  }

  /**
   * Find out next free position on the plate, by looking into the array of plate
   * positions, which do not yet have barcode assigned.
   * If there are no more free positions available, return -1
   */
  nextPostionOnPlate() {
    for(let value of this.arrayOfPlatePositionsAndBarcodes ) {
      if(value[1] === null) {
        return this.arrayOfPlatePositionsAndBarcodes.indexOf(value);
      }
    }
    return -1;
  }

  /**
   * Return where the sample is in the positional array, so it can be removed.
   * @param barcode
   */
  sampleInPositionalArray(barcode: string) {
    for(let value of this.arrayOfPlatePositionsAndBarcodes ) {
      if (value[1] === barcode) {
        return this.arrayOfPlatePositionsAndBarcodes.indexOf(value);
      }
    }
    return -1;
  }

  /**
   * For the index in the arrayOfPlatePositionsAndBarcodes, assign the barcode of the sample
   * @param barcode The sample barcode
   * @param index index in arrayOfPlatePositionsAndBarcodes
   */
  placeOnPlateArray(barcode: string, index: number) {
    this.arrayOfPlatePositionsAndBarcodes[index][1] = barcode;
    return this.arrayOfPlatePositionsAndBarcodes[index][0];
  }

  /**
   * For the worklist view update the sample position
   * @param barcode Sample barcode
   * @param position Position assigned to the sample on the plate
   * @param add boolean to indicate whether sample is being added or removed from plate
   */
  updateSamplePositionOnWorkList(barcode: string, position: string, add: boolean) {
    if (add) {
      this.workListSampleList.forEach(sample => {
        if (sample.barcode === barcode) {
          sample.position = position;
          this.updateSampleToPlateData(barcode, sample.sampleName, sample.projectName, position, add);
        }
      });
    } else {
      this.workListSampleList.forEach(sample => {
        if (sample.barcode === barcode) {
          this.updateSampleToPlateData(barcode, sample.sampleName, sample.projectName, position, add);
          sample.position = null;
        }
      });
    }
  }

  /**
   * Method to convert the <Position, Barcode> map into <Barcode, Position>
   * @param sourceMap The source map of <Position, Barcode>
   */
  mapToStringList(sourceMap ) {
    let stringList: string[] = [];
    for(let key of Array.from(sourceMap.keys())) {
      stringList.push(key +","+sourceMap.get(key));
    }
    return stringList;
  }

  /**
   * If plateview is clicked the first time, fetch the plate details
   * If label name is plate view change to List view
   * If Table is viewed, View plate. Else View Table.
   * @param Event Even is Plate View button being clicked.
   */
  handlePlateView(Event: any) {

    if(this.plateViewFetched === false) {
      this.plateData = this.plateData.filter(function(obj) {
        return obj.newlyPlaced === true;
      });
      /* Make back-end call to get the details for the Lib1 plate.
      */
      this.workListService.getPlateViewDetails(this.plate1Barcode).subscribe(
        results => {
          if(!results) {
            this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error Fetching Plate Details', detail: ''});
            return;
          }
          this.plateViewFetched = true;
          // Insert each of the fetched results one by one
          results.data.forEach(sample => {
            this.plateData.push(sample);
          });

          // Find the max occupied column in the samples.
          this.initializeMaxCol(results.data);
          this.populateBlockedMap();
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        });
    }

    // Change button Label
    if(this.plateViewButtonLabel === 'List View') {
      this.plateViewButtonLabel = 'Plate View';
    } else {
      this.plateViewButtonLabel = 'List View';
    }

    // Alternate the view
    this.viewTable = !this.viewTable;
  }

  /**
   * Find the sample at i,j position in the plate
   * If there are no samples, and it's within the column positions of the samples already on the plate,
   * then return a dummy sample with name 'BLOCKED'
   * @param i The row index
   * @param j The column index
   */
  getSampleAt(i: number, j: number) {

    for(let sample of this.plateData) {
      if( ( sample.positionRow - 1 ) === i && ( sample.positionCol - 1 ) === j) {
        return sample;
      }
    }

    // If column range within the number of columns already occupied
    if(this.blockedMap.has(this.getRowColStringFromPos(i,j))) {
      return {'barcode' : '', 'name' : 'BLOCKED', 'projectName' : '', 'positionRow' : i, 'positionCol' : j, 'newlyPlaced' : false};
    }
    return {'barcode' : '', 'name' : '', 'projectName' : '', 'positionRow' : i, 'positionCol' : j, 'newlyPlaced' : false};
  }


  /**
   * Convert a AlphaNum format position into row, col
   * @param position Position in the <AlphaNum> format
   */
  getRowColumnNumberFromPosition(position: string): number[] {
    let row = position.charCodeAt(0) - 64;
    let col = parseInt(position.substring(1), 10);
    return [row, col];
  }

  /**
   * Function to update the plate sample data
   * @param barcode Sample Barcode
   * @param sampleName Sample Name
   * @param projectName Project name
   * @param position Position in AlphaNum format
   * @param add Boolean to indicate add or remove from plate
   */
  updateSampleToPlateData(barcode: string, sampleName: string, projectName: string, position: string, add: boolean) {

    let rowCol: number[] = this.getRowColumnNumberFromPosition(position);

    if(add) {
          this.plateData.push({'barcode' : barcode, 'name' : sampleName, 'projectName' : projectName, 'positionRow' : rowCol[0], 'positionCol' : rowCol[1], 'newlyPlaced' : true,  'concentration':0.0, 'assayType':null});
    } else {
      this.plateData = this.plateData.filter(function (obj) {
        return obj.barcode !== barcode;
      });
    }
  }

  /**
   * Initialize the max column available.
   * @param plateData Plate Data returned from backend
   */
  initializeMaxCol(plateData : SampleDetailsDTO[] ) {
    for(let sample of plateData) {
      if(sample.positionCol > this.maxCol) {
        this.maxCol = sample.positionCol;
      }
    }
  }

  /**
   * Populate the blocked position map, makes it faster to fetch the data.
   */
  populateBlockedMap() {
    for(let j = 0; j < this.maxCol; j++) {
      for(let i = 0; i < 8; i++) {
        let sample = this.getSampleAt(i, j);
        if(sample.name === '' && sample.barcode === '' && sample.projectName === '') {
          this.blockedMap.set(this.getRowColStringFromPos(i, j), true);
        }
      }
    }
  }

  /**
   * Block-unblock a cell in the plate
   * @param rowVal Row value of cell
   * @param colVal Column value of cell
   */
  blockUnblock(rowVal: number, colVal: number) {
    console.log('Clicked at: [ ' + rowVal + ', ' + colVal + ' ]');
    let rcstring = this.getRowColStringFromPos(rowVal, colVal);
    let sampleAtGivenPosition = this.getSampleAt(rowVal, colVal);
    if (sampleAtGivenPosition.name === '' && sampleAtGivenPosition.barcode === '' && sampleAtGivenPosition.projectName === '') {
      this.blockedMap.set(rcstring, true);
      let index = this.arrayOfPlatePositionsAndBarcodes.findIndex(x => x[0] === rcstring);
      if (index > -1) {
        this.arrayOfPlatePositionsAndBarcodes.splice(index, 1);
      }
    } else if(sampleAtGivenPosition.name === 'BLOCKED') {
      this.blockedMap.delete(rcstring);
      this.arrayOfPlatePositionsAndBarcodes.push([rcstring, null]);
      this.arrayOfPlatePositionsAndBarcodes.sort((a, b) => {
        let aVal = this.getPositionalValues(a[0]);
        let bVal = this.getPositionalValues(b[0]);
        if ( aVal < bVal ) {
          return -1;
        } else if ( aVal > bVal) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return;
  }

  /**
   * Get the positional String from row and col number.
   * Ex: (1, 1) returns 'A1'
   * @param row
   * @param col
   */
  getRowColStringFromPos(row: number, col: number) {
    return this.rowHeaders[row] + this.columnHeaders[col];
  }

  /**
   * Get the serial value for the given positional string e.g., 'A1' equals 1
   * Helper function for sort
   * @param positionalString
   */
  getPositionalValues(positionalString: string) {
    let rowCol = this.getRowColumnNumberFromPosition(positionalString);
    return ( rowCol[1] * 8 ) + rowCol[0];
  }
}

